import { CLIENT_DISPATCH_TARGET_MASTER } from "redux/clientDispatchMeta";
import { IClient } from "../models/client";

export interface IClientState {
  isLoaded: boolean;
  error?: any;
  clients?: IClient[];
  client: IClient;
}

export interface IClientAction {
  type: string;
  payload: any;
  meta?: { clientDispatchTarget?: typeof CLIENT_DISPATCH_TARGET_MASTER };
}

const initialState: IClientState = {
  isLoaded: false,
  error: null,
  clients: [],
  client: null,
};

export default function MasterClientReducer(state = initialState, action: IClientAction) {
  switch (action.type) {
    case "client.update":
      if (action.meta?.clientDispatchTarget !== CLIENT_DISPATCH_TARGET_MASTER) {
        return state;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return {
        ...state,
        ...action.payload,
      };
    case "client.select":
      if (action.meta?.clientDispatchTarget !== CLIENT_DISPATCH_TARGET_MASTER) {
        return state;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
